export default __webpack_public_path__ + "static/gallery-writing-humor-d97bdd39100dc41f7571e3cc49d57694.png";